module.exports = __webpack_public_path__ + "img/profile-male.8f2b4f02.svg";